import { registerGlobalAPI } from './utils/api.js'

registerGlobalAPI()
